import { InputWrapper } from "../../wrappers";
import { CommonSelectProps } from "./CommonSelect.types";

import Select from "react-select";
import { override, styles } from "./CommonSelect.styles";
import { FormatOptionLabel } from "./FormatOptionLabel/FormatOptionLabel";

import "simplebar-react/dist/simplebar.min.css";

export const CommonSelect = ({
  placeholder,
  onChange,
  options,
  value,
  clearOnValueContainerClick = true,
  isSearchable,
  filterOption,
  noOptionsMessage,
  ...props
}: CommonSelectProps) => (
  <InputWrapper {...props}>
    <Select
      components={override(Boolean(props.errorMessage), onChange, clearOnValueContainerClick)}
      styles={styles(Boolean(props.errorMessage))}
      formatOptionLabel={FormatOptionLabel}
      placeholder={placeholder}
      onChange={onChange}
      isSearchable={!!isSearchable}
      filterOption={filterOption}
      noOptionsMessage={noOptionsMessage}
      options={options}
      value={value}
    />
  </InputWrapper>
);
